import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ItiMenuItem } from './../';

@Component({
    components: {
        ItiMenuOption: () => import('./../option/iti-menu-option.vue'),
     },
})
export default class ItiMenuGroup extends Vue {
    @Prop() public item!: ItiMenuItem;
    @Prop() public rootGroup!: boolean;
}
